export const getEnvConfVal = (name: string): string => {
    const val = get(name)
    if (!val) throw new Error(`Missing "${name}" config value`)
    return val
}

export const getOptionalEnvConfVal = (name: string): string | null => {
    return get(name) || null
}

const get = (key: string): string | null | undefined => {
    let val
    const meta = document.querySelector(`meta[name=${key}]`)
    if (meta) val = meta.getAttribute('content')

    // console.log('val: ', val)
    return val
}
